import React from 'react';
import { Skeleton, Tooltip } from 'antd';
import { Link } from 'react-router-dom';

const PointsDisplay = ({ pointsBalance, loading }) => (
  <div className="points-inline">
    <span className="muted">可用积分</span>
    {loading ? (
      <Skeleton.Input active={false} size="small" style={{ width: 56 }} />
    ) : (
      <Tooltip
        title={
          pointsBalance == null
            ? '余额暂不可用，请刷新后重试'
            : '每个待审核订单转为待拍单消耗 1 积分'
        }
      >
        <strong>
          {pointsBalance == null ? '暂不可用' : pointsBalance.toLocaleString()}
        </strong>
      </Tooltip>
    )}
    <Link to="/app/points">明细</Link>
  </div>
);
export default PointsDisplay;
